export const ExtraLinks = {
  playStore: 'https://play.google.com/store/apps/details?id=com.cscs.smarttech',
  appStore: 'https://apps.apple.com/gb/app/cscs-smart-check/id1607797605',
}
